import { loadAuth } from '@/libs/store/auth';
import { loadDevices } from '@/libs/store/device';
import { setError } from '@/libs/store/error';
import { loadProperties, updateTargetName } from '@/libs/store/property';
import { loadRooms, resetSelectedRoomIds } from '@/libs/store/room';
import { loadSession } from '@/libs/store/session';
import Store from '@/store';

export function findRoomById(roomId: string) {
  return Store.getters.rooms.find((room: any) => room.roomId === roomId);
}

export async function authenticate() {
  try {
    await loadSession();
    return true;
  } catch {
    return false;
  }
}

export async function loadAuthProperty() {
  try {
    await Promise.all([loadAuth(), loadProperties()]);
  } catch (e) {
    setError(e.message);
    return;
  }
  const { targetName } = Store.getters.selectedProperty;
  if (targetName !== Store.getters.targetName) {
    await updateSelectedProperty(targetName);
  }
}

export async function updateSelectedProperty(targetName: string) {
  updateTargetName(targetName);
  try {
    await Promise.all([loadRooms(targetName), loadDevices(targetName)]);
  } catch (e) {
    setError(e.message);
  } finally {
    resetSelectedRoomIds();
  }
}
